/**
 * Annotation 타입 정의
 * 이미지 위에 형광펜/밑줄 annotation을 추가하는 기능을 위한 타입
 */

/** Annotation 도구 타입 */
export type AnnotationType = 'highlighter' | 'underline';

/** Annotation 도구 (도구바용) */
export type AnnotationTool = 'highlighter' | 'underline' | 'eraser' | 'none';

/** 밑줄 스타일 */
export type UnderlineStyle = 'solid' | 'dashed' | 'wavy';

/**
 * Annotation 좌표 (상대좌표: 0.0 ~ 1.0)
 * 이미지 너비/높이 대비 비율로 저장되어
 * 이미지 크기 변경 시에도 비례하여 유지됨
 */
export interface AnnotationPoint {
  x: number; // 0.0 ~ 1.0 (이미지 너비 대비 비율)
  y: number; // 0.0 ~ 1.0 (이미지 높이 대비 비율)
}

/** Annotation 공통 속성 */
export interface BaseAnnotation {
  id: string;
  type: AnnotationType;
  color: string;
  strokeWidth: number; // 픽셀 단위 (이미지 원본 기준)
  createdAt: number;
}

/** 형광펜 Annotation (자유 드로잉) */
export interface HighlighterAnnotation extends BaseAnnotation {
  type: 'highlighter';
  points: AnnotationPoint[]; // 자유 드로잉 경로
  opacity: number; // 0.0 ~ 1.0
}

/** 밑줄 Annotation (직선) */
export interface UnderlineAnnotation extends BaseAnnotation {
  type: 'underline';
  startPoint: AnnotationPoint;
  endPoint: AnnotationPoint;
  style: UnderlineStyle;
}

/** Annotation union 타입 */
export type Annotation = HighlighterAnnotation | UnderlineAnnotation;

/** Annotation 상태 (useAnnotation 훅에서 사용) */
export interface AnnotationState {
  annotations: Annotation[];
  currentTool: AnnotationTool;
  currentColor: string;
  currentStrokeWidth: number;
  currentOpacity: number; // 형광펜용
  currentUnderlineStyle: UnderlineStyle; // 밑줄용
}

/** 형광펜 기본 색상 팔레트 */
export const HIGHLIGHTER_COLORS = [
  '#FFFF00', // 노랑
  '#00FF00', // 초록
  '#FF69B4', // 분홍
  '#00BFFF', // 파랑
  '#FFA500', // 주황
] as const;

/** 밑줄 기본 색상 팔레트 */
export const UNDERLINE_COLORS = [
  '#FF0000', // 빨강
  '#0000FF', // 파랑
  '#000000', // 검정
  '#008000', // 초록
] as const;

/** Annotation 기본값 */
export const ANNOTATION_DEFAULTS = {
  highlighter: {
    strokeWidth: 20,
    opacity: 0.4,
    color: HIGHLIGHTER_COLORS[0],
  },
  underline: {
    strokeWidth: 3,
    style: 'solid' as UnderlineStyle,
    color: UNDERLINE_COLORS[0],
  },
} as const;
